<a href="javascript:;"
   routerLink="/activity-list/{{activityId}}"> 
    <img src="./assets/media/svg/icons/General/Edit-3.svg" title="Edit">
</a>

&nbsp; 

<span *ngIf="displayRelation"> <img src="./assets/media/svg/icons/General/delete.svg" placement="bottom" title="Delete" (click)="invokeDeleteActivity()"></span>